var map = {
	"./hk/en-hk-modelData.json": 929,
	"./hk/en-hk.json": 921,
	"./hk/zh-hk-modelData.json": 930,
	"./hk/zh-hk.json": 982,
	"./in/in-modelData.json": 931,
	"./in/in.json": 983,
	"./kr/kr-modelData.json": 932,
	"./kr/kr.json": 984,
	"./sg/sg-modelData.json": 933,
	"./sg/sg.json": 985,
	"./tw/tw-modelData.json": 934,
	"./tw/tw.json": 986,
	"./wechat/cn-modelData.json": 935
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 920;


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/scripts/gogovan/order ^\.\/.*\.json$
// module id = 920
// module chunks = 0 1